import { Brand, make } from 'ts-brand';

export type Dollar = Brand<number, 'dollar'>;
export const makeDollar = make<Dollar>();
export const ZERO_DOLLARS = makeDollar(0);

export type Cent = Brand<number, 'cent'>;
export const makeCent = make<Cent>();
export const ZERO_CENTS = makeCent(0);
